export default __webpack_public_path__ + "static/media/headshot.4acc0ffc.JPG";